import { render } from "./SectionAttendanceCorrection.vue?vue&type=template&id=9f5de87c&scoped=true"
import script from "./SectionAttendanceCorrection.vue?vue&type=script&lang=js"
export * from "./SectionAttendanceCorrection.vue?vue&type=script&lang=js"

import "./SectionAttendanceCorrection.vue?vue&type=style&index=0&id=9f5de87c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f5de87c"]])

export default __exports__